import React, { useContext } from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { Url } from '@wix/da-url';
import { SisuContext } from '../../Context';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import { ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
var Head = function (_a) {
    var _b = _a.pageTitle, pageTitle = _b === void 0 ? 'DeviantArt' : _b, _c = _a.pageDescription, pageDescription = _c === void 0 ? "DeviantArt is the world's largest online social community for artists and art enthusiasts, allowing people to connect through the creation and sharing of art." : _c, pageUrl = _a.pageUrl, _d = _a.pageThumb, pageThumb = _d === void 0 ? Url.staticCDNLink('minish/main/logo/card_black_large.png') : _d, isMobile = _a.isMobile, isIOS = _a.isIOS, environment = _a.environment, language = _a.language, prevUrl = _a.prevUrl, nextUrl = _a.nextUrl, theme = _a.theme, flags = _a.flags, themeSkin = _a.themeSkin, bodyClassName = _a.bodyClassName, hasNewChatMessage = _a.hasNewChatMessage, _e = _a.allowAppBanner, allowAppBanner = _e === void 0 ? true : _e;
    var isSisu = useContext(SisuContext);
    return (React.createElement(Helmet, { htmlAttributes: {
            lang: language,
        }, bodyAttributes: {
            class: classnames(getGlobalClassnamesForContext({
                isMobile: isMobile,
                theme: theme,
                flags: flags,
                themeSkin: themeSkin,
            }), bodyClassName),
        } },
        React.createElement("meta", { charSet: "utf-8" }),
        React.createElement("title", null, pageTitle),
        preconnectDomains(),
        preloadFonts(),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "180x180", href: Url.staticCDNLink('eclipse/icons/ios-180.png') }),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "152x152", href: Url.staticCDNLink('eclipse/icons/ios-152.png') }),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "120x120", href: Url.staticCDNLink('eclipse/icons/ios-120.png') }),
        React.createElement("link", { rel: "apple-touch-icon", sizes: "76x76", href: Url.staticCDNLink('eclipse/icons/ios-76.png') }),
        React.createElement("link", { rel: "icon", sizes: "192x192", href: Url.staticCDNLink('eclipse/icons/android-192.png') }),
        React.createElement("link", { rel: "icon", sizes: "144x144", href: Url.staticCDNLink('eclipse/icons/android-144.png') }),
        React.createElement("link", { rel: "icon", sizes: "96x96", href: Url.staticCDNLink('eclipse/icons/android-96.png') }),
        React.createElement("link", { rel: "icon", sizes: "48x48", href: Url.staticCDNLink('eclipse/icons/android-48.png') }),
        React.createElement("link", { rel: "mask-icon", href: Url.staticCDNLink('eclipse/icons/touchbar-mark-v2.svg'), color: "#00e59b" }),
        React.createElement("link", { rel: "icon", sizes: "16x16", type: "image/png", href: Url.staticCDNLink('eclipse/icons/favicon-v2-16x16.png') }),
        React.createElement("link", { rel: "icon", sizes: "32x32", type: "image/png", href: Url.staticCDNLink('eclipse/icons/favicon-v2-32x32.png') }),
        React.createElement("link", { href: getFavIcon(environment, hasNewChatMessage), rel: "shortcut icon" }),
        React.createElement("link", { rel: "canonical", href: Url.buildFromPath(pageUrl) }),
        prevUrl && React.createElement("link", { href: prevUrl, rel: "prev" }),
        nextUrl && React.createElement("link", { href: nextUrl, rel: "next" }),
        React.createElement("meta", { name: "application-name", content: "DeviantArt" }),
        React.createElement("meta", { name: "description", content: pageDescription }),
        React.createElement("meta", { property: "og:type", content: "website" }),
        React.createElement("meta", { property: "og:url", content: Url.buildFromPath(pageUrl) }),
        React.createElement("meta", { property: "og:title", content: pageTitle }),
        React.createElement("meta", { property: "og:image", content: pageThumb }),
        React.createElement("meta", { property: "og:description", content: pageDescription }),
        React.createElement("meta", { property: "fb:page_id", content: "6452638289" }),
        React.createElement("meta", { property: "twitter:account_id", content: "1239671" }),
        React.createElement("meta", { name: "twitter:site", content: "@deviantart" }),
        React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
        React.createElement("meta", { name: "twitter:title", content: pageTitle }),
        React.createElement("meta", { name: "twitter:description", content: pageDescription }),
        React.createElement("meta", { name: "twitter:image", content: pageThumb }),
        React.createElement("meta", { name: "theme-color", content: theme === ThemeOptions.DARK ? '#06070d' : '#ffffff' }),
        isMobile && (React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1".concat(isIOS ? ', maximum-scale=1' : '') })),
        React.createElement("link", { href: Url.staticCDNLink('native/journal_thumbs.css?12'), rel: "stylesheet" }),
        React.createElement("link", { href: "https://static.parastorage.com/unpkg/augmented-ui@1.1.2/augmented.css", rel: "stylesheet" }),
        !isSisu && allowAppBanner && (React.createElement("meta", { name: "apple-itunes-app", content: "app-id=925219396" }))));
};
Head.displayName = 'Head';
// We preload just the woff2, they are better compressed and have good support
// especially on browsers that support preload :)
function preloadFonts() {
    var fonts = [
        [Url.staticCDNLink('misc/symbols/deviantart-symbols6.woff2'), 'font/woff2'],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_bd.woff2'),
            'font/woff2',
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_xbd.woff2'),
            'font/woff2',
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_lt.woff2'),
            'font/woff2',
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_md.woff2'),
            'font/woff2',
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_rg.woff2'),
            'font/woff2',
        ],
    ];
    return fonts.map(function (font) { return (React.createElement("link", { key: font[0], rel: "preload", href: font[0], as: "font", type: font[1], crossOrigin: 'anonymous' })); });
}
function preconnectDomains() {
    var domains = [
        'https://a.deviantart.net',
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com',
        'https://st.deviantart.net',
        'https://static.parastorage.com',
        'https://www.wix.com',
    ];
    return domains.map(function (domain) { return (React.createElement("link", { key: domain, rel: "preconnect", href: domain })); });
}
function getFavIcon(env, hasNewChatMessage) {
    if (hasNewChatMessage) {
        switch (env) {
            // same icon for dev / rc
            case 'dev':
            case 'rc':
                return Url.staticCDNLink('eclipse/icons/favicon-dot-staging_32x32.png');
            default:
                return Url.staticCDNLink('eclipse/icons/favicon-dot_32x32.png');
        }
    }
    switch (env) {
        case 'dev':
            return Url.staticCDNLink('eclipse/icons/da_favicon_vm_v2.ico?1');
        case 'rc':
            return Url.staticCDNLink('eclipse/icons/da_favicon_staging_v2.ico');
        default:
            return Url.staticCDNLink('eclipse/icons/da_favicon_v2.ico');
    }
}
export default Head;
//# sourceMappingURL=Head.js.map